'use strict';

export default (() => {

    var _self,
        ui,
        wrap;

    return {

        init: function(options) {
            _self = this;

            if (options.wrap) {
                wrap = options.wrap;
            }

            if (wrap) {
                ui = {
                    select: wrap.querySelector('.js-nav-pagination-select')
                };

                _self.bindUIActions();
            }
        },

        bindUIActions: function() {
            if (ui.select) {
                ui.select.addEventListener('change', _self.changePaginationCount);
            }
        },

        changePaginationCount: function() {
            var data = $(ui.select).find(':selected').data('pagination-count');
            window.location = data;
        }

    };

})();
